module.exports = __webpack_public_path__ + "static/img/product_10.4eec973.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_10.jpg
// module id = p7z8
// module chunks = 2